"use client";

import { Link } from "@/components/link";

import type { FacetOption } from "./facet-option-list";
import { facetOptionRowClassName } from "./facet-option-row-class-name";
import { FacetOptionRowContent } from "./facet-option-row-content";

export function FacetOptionRow({
  item,
  value,
  maxCount,
  onChange,
  formatCount,
}: {
  item: FacetOption;
  value: string | undefined;
  maxCount: number;
  onChange: (value: string | undefined) => void;
  formatCount: (count: number) => string;
}) {
  const isActive = value === item.value;
  const disabled = item.disabled === true && !isActive;
  const barWidth = item.count != null && maxCount > 0 ? (item.count / maxCount) * 100 : 0;
  const className = facetOptionRowClassName(item, isActive, disabled);
  const content = (
    <FacetOptionRowContent
      item={item}
      isActive={isActive}
      disabled={disabled}
      barWidth={barWidth}
      formatCount={formatCount}
    />
  );
  // Filter links are variants of this noindex search page.
  if (item.link && !disabled) {
    return (
      <Link
        {...item.link}
        rel="nofollow"
        resetScroll={false}
        aria-current={isActive ? "page" : undefined}
        className={className}
      >
        {content}
      </Link>
    );
  }
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={isActive}
      onClick={() => onChange(isActive ? undefined : item.value)}
      className={className}
    >
      {content}
    </button>
  );
}
